module.exports = __webpack_public_path__ + "static/media/BgPageRegister.8ad56176.png";